import * as React from 'react';
import { Layout } from '../Layout';
import * as style from './OffersBlock.css';

export interface IPriceProps {
  title: React.ReactNode;
  offers: React.ReactNode;
  layoutsEntry: React.ReactNode;
  priceRelevance: React.ReactNode;
}

export function OffersBlock({ title, offers, layoutsEntry, priceRelevance }: IPriceProps) {
  return (
    <Layout>
      {title}
      <div className={style['relevance']}>{priceRelevance}</div>
      <div className={style['container']}>
        <div className={style['offers']}>{offers}</div>
        <div className={style['layouts-entry']}>{layoutsEntry}</div>
      </div>
    </Layout>
  );
}
